import { render, staticRenderFns } from "./PreviewFormPage.vue?vue&type=template&id=a50383cc"
import script from "./PreviewFormPage.vue?vue&type=script&lang=js"
export * from "./PreviewFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18._nmhmfp7tgz4zl4skblclfv2nbu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports